import {PhoneNumber} from './phoneNumber.js';

export var PhoneNumbers = function(phoneNumbersData) {
    var phoneNumbers = {};
    
    // Constructor
    if (phoneNumbersData) {
        if (phoneNumbersData.home) {
            phoneNumbers.home = PhoneNumber(phoneNumbersData.home);
        }
        if (phoneNumbersData.mobile) {
            phoneNumbers.mobile = PhoneNumber(phoneNumbersData.mobile);
        }
        if (phoneNumbersData.work) {
            phoneNumbers.work = PhoneNumber(phoneNumbersData.work);
        }
        if (phoneNumbersData.fax) {
            phoneNumbers.fax = PhoneNumber(phoneNumbersData.fax);
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return phoneNumbers;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/phoneNumbers.js
// module id = 17
// module chunks = 0